const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

// In-memory wishlist to prevent race conditions
let currentWishlist = [];

const selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
    productCard: '.product-card',
};

document.addEventListener('DOMContentLoaded', () => {
    // Initialize in-memory wishlist from localStorage on page load
    currentWishlist = getWishlistFromStorage();
    
    var text = document.getElementsByClassName("product-recommendations");
    var len = text.length;
    if (!len) initButtons();
    initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
    const isOnWishlistPage = !!document.querySelector(selectors.grid);
    if (!isOnWishlistPage) {
        initGrid();
    }
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {});
document.addEventListener('shopify-wishlist:init-buttons', (event) => {});

const fetchProductCardHTML = (handle) => {
    const productTileTemplateUrl = `/products/${handle}?view=card-wishlist`;
    return fetch(productTileTemplateUrl)
        .then((res) => {
            if (!res.ok) return null;
            return res.text();
        })
        .then((res) => {
            if (!res) return null;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(res, 'text/html');
            const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
            if (!productCard) return null;
            return productCard.outerHTML;
        })
        .catch((err) => {
            console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
            return null;
        });
};

const setupGrid = async (grid) => {
    const wishlist = getWishlist();

    if (wishlist.length === 0) {
        grid.innerHTML = '';
        grid.classList.add(GRID_LOADED_CLASS);
        updateWishlistCount();
        return;
    }

    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);

    const validResponses = responses.filter(html => html && html.trim() !== '');
    const validHandles = wishlist.filter((_, i) => responses[i] && responses[i].trim() !== '');

    // Silently sync localStorage if any products were deleted/unavailable
    if (validHandles.length !== wishlist.length) {
        currentWishlist = validHandles;
        saveToStorage(validHandles);
        updateWishlistCount();
    }

    grid.innerHTML = validResponses.join(' ');
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    const event = new CustomEvent('shopify-wishlist:init-product-grid', {
        detail: { wishlist: validHandles }
    });
    document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
    buttons.forEach((button) => {
        const productHandle = button.dataset.productHandle || false;

        if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute.');

        // Set active class based on in-memory wishlist
        if (currentWishlist.includes(productHandle)) {
            button.classList.add(BUTTON_ACTIVE_CLASS);
        } else {
            button.classList.remove(BUTTON_ACTIVE_CLASS);
        }

        // Clone to remove old listeners and prevent duplicates
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener('click', () => {
            const isOnWishlistPage = !!document.querySelector(selectors.grid);

            if (isOnWishlistPage) {
                // Remove from in-memory array immediately (no race condition)
                const index = currentWishlist.indexOf(productHandle);
                if (index > -1) {
                    currentWishlist.splice(index, 1);
                }

                // Save updated in-memory array to localStorage immediately
                saveToStorage(currentWishlist);

                // Remove card from DOM
                const card = newButton.closest(selectors.productCard);
                if (card) card.remove();

                // Update count from in-memory array
                updateWishlistCount();

                // Show empty message if no products left
                if (currentWishlist.length === 0) {
                    $(".wish-info").css("display", "block");
                }

            } else {
                // Shop/other pages — normal add/remove toggle
                const index = currentWishlist.indexOf(productHandle);
                if (index === -1) {
                    currentWishlist.push(productHandle);
                    newButton.classList.add(BUTTON_ACTIVE_CLASS);
                } else {
                    currentWishlist.splice(index, 1);
                    newButton.classList.remove(BUTTON_ACTIVE_CLASS);
                }

                // Save to localStorage
                saveToStorage(currentWishlist);
                updateWishlistCount();

                // Dispatch event for other pages
                const event = new CustomEvent('shopify-wishlist:updated', {
                    detail: { wishlist: currentWishlist }
                });
                document.dispatchEvent(event);
            }
        });
    });
};

// Save array to localStorage directly
const saveToStorage = (array) => {
    if (array.length) {
        localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, array.join(LOCAL_STORAGE_DELIMITER));
    } else {
        localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    }
};

const initGrid = () => {
    const grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
};

const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
    else return;
    const event = new CustomEvent('shopify-wishlist:init-buttons', {
        detail: { wishlist: getWishlist() }
    });
    document.dispatchEvent(event);
};

// Read from localStorage
const getWishlistFromStorage = () => {
    const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
    return [];
};

// Always return in-memory wishlist (no race condition)
const getWishlist = () => {
    return currentWishlist;
};

const setWishlist = (array) => {
    currentWishlist = array;
    saveToStorage(array);

    const event = new CustomEvent('shopify-wishlist:updated', {
        detail: { wishlist: array }
    });
    updateWishlistCount();
    document.dispatchEvent(event);

    return array.join(LOCAL_STORAGE_DELIMITER);
};

const updateWishlist = (handle) => {
    const index = currentWishlist.indexOf(handle);
    if (index === -1) currentWishlist.push(handle);
    else currentWishlist.splice(index, 1);
    return setWishlist([...currentWishlist]);
};

const wishlistContains = (handle) => {
    return currentWishlist.includes(handle);
};

const resetWishlist = () => {
    return setWishlist([]);
};

const updateWishlistCount = () => {
    // Always use in-memory array for count
    const count = currentWishlist.length;
    $('[data-js-wishlist-count]').attr('data-js-wishlist-count', count).html(count);

    if (count === 0) {
        $(".wish-info").css("display", "block");
    } else {
        $(".wish-info").css("display", "none");
    }
};

$(document).ready(function () {
    updateWishlistCount();
});